<template>
  <div>
    Domain: <select v-model="domain_uuid">
      <option value="">All Domains</option>
      <option v-for="entry in domain_data" :key=entry[0] :value="entry[0]">{{entry[1]}}</option>
    </select><br/>
    Min face height: <input v-model="min_face_height" /><br/>
    <input type="button" v-on:click="setValues()" value="Update" />
    <font color="red"><b>{{this.err}}</b></font>
  </div>
</template>

<script>
import {store} from '@/store'
import {makeRequest} from '@/api/base'

export default {
  name: 'DomainSelector',
  data() {
    return {
      domain_uuid: '',
      min_face_height: 0,
      err: '',
      loaded: false,
      domain_data: [
        ["ee458dad-72ad-41bb-b9df-1c69cd0649be","130 E 18th St, Brooklyn"],
        ["0ab840f1-034d-4ab0-90ef-60d7e05475f1","1314 Ocean Parkway"],
        ["7e199f08-9cdc-4775-acd7-e178d137de01","1340 E 9th St"],
        ["b9a142fb-11ad-4221-87d6-91460be7bb32","2026 Ocean Ave"],
        ["27d9cd17-b6fa-4ae6-b558-8fe4f045b40d","2055 Ocean Ave"],
        ["758b5f64-53ee-4cf1-ae3b-2ccea8368e13","2103 Honeywell, Bronx. Lineage."],
        ["4cd87f70-d076-4315-870d-04b8f739141b","2115 Honeywell, Bronx. Lineage."],
        ["7ce33552-8268-48ff-881c-48c4c33e93a4","2409_arthur"],
        ["015de5c4-6279-4513-bbba-23fa904574e2","3033 Coney Island Ave"],
        ["3fb61e7f-6842-49d8-8353-15e714e2b6af","309 E 92 St."],
        ["e502b9f5-fca0-4bac-b807-c6f8ae99b653","3130 Brighton"],
        ["591b00cc-d214-43a7-8865-273868967898","580 5th Ave - Diamond Building"],
        ["37032842-c3ec-4783-b35c-8db5a2237b84","Carroll St"],
        ["e0cc02c0-a117-476d-8e6d-bcd4eaeb3b14","Centre Square, Philadelphia"],
        ["0a6b622c-713f-4ba3-a822-d3da36b66966","Chaim's House"],
        ["fffa8265-fdf2-4aea-ac2a-d11513992459","Digital Pavilion, 1014 Stanley Ave."],
        ["adf3d40b-8f18-442c-bc8a-00a8f2ccf870","E14th MYRCB Student Housing"],
        ["7d47ced7-54d2-4df6-932d-2436500ab454","Harlem"],
        ["444a663e-935d-49dd-83b0-700b98934eb6","Hudsonview Terrace"],
        ["045702d0-7e61-4f85-ae0f-df1efd0854eb", "LeFrak - 9608 57th Ave, Corona"],
        ["0e5ba6aa-5281-43f2-b6e2-90fb07ceb9fc","Newell St"],
        ["d2180c02-4974-4a4b-b070-316122912202","Planned Companies - one camera potential investor"],
        ["30894e61-3cf2-49c6-a9e4-94ce3c78ffb5","Pointe at Troy"],
        ["64976fd7-1ec8-4a60-9cc9-891d7ec46389","Rego Park"],
        ["751f2a9c-9d3e-49ab-a5dc-1bc6a1c34aa0","Steady Connections pilot camera, Monsey, NY"],
        ["2622d6f8-1143-45d0-be8b-e450efa54167","Virtual Security, 483 Oak Glen, Howell NJ -- CONFIRM ADDR"],
        ["91dee1d0-420c-4726-afd7-b36d5be09570","Westchester Center for Assisted Living"],
        ["e56113cc-a293-45c3-90ca-64867d5581e6","YA test domain for WLN"],
      ]
    }
  },
  methods: {
    setValues: function() {
      try {
        this.$store.commit('setDomainUUID', this.domain_uuid);
        if (isNaN(this.min_face_height)) {
          this.err = "min face height is not a number. not set";
        } else {
          this.$store.commit('setMinFaceHeight', parseInt(this.min_face_height))
          this.err = ''
        }
      } catch (err) {
        this.err = err.message;
      }
    }
  },
  mounted: function() {
    this.domain_uuid = this.$store.getters.domainUUID;
    try {
      this.min_face_height = this.$store.getters.minFaceHeight;
      this.err = ""
    } catch (err) {
      this.err = err.message;
    }
    // this.loadData();
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DomainSelector.vue?2c6073e9